import { defineMessages } from "react-intl"

export default defineMessages({
  createAccount: {
    defaultMessage: "Create Account",
    id: "src.components.LoginDialog.createAccount.button",
  },
  email: {
    defaultMessage: "Email",
    id: "src.components.LoginDialog.email.placeholder",
  },
  forgotPassword: {
    defaultMessage: "Forgot Password?",
    id: "src.components.LoginDialog.forgotPassword.button",
  },
  login: {
    defaultMessage: "Login",
    id: "src.components.LoginDialog.login.button",
  },
  loginFailed: {
    defaultMessage: "Login failed",
    id: "src.components.LoginDialog.loginFailed",
  },
  mfaFailed: {
    defaultMessage: "MFA failed",
    id: "src.components.LoginDialog.mfaFailed",
  },
  mfaTitle: {
    defaultMessage:
      "We've detected a login from a new device. For security reasons, please enter the verification code we've sent you",
    id: "src.components.LoginDialog.mfaTitle",
  },
  password: {
    defaultMessage: "Password",
    id: "src.components.LoginDialog.password.placeholder",
  },
  passwordResetLinkSent: {
    defaultMessage: "Password Reset Link Sent",
    id: "src.components.LoginDialog.passwordResetLinkSent",
  },
  phoneNumber: {
    defaultMessage: "Phone Number",
    id: "src.components.LoginDialog.phoneNumber",
  },
  resendCode: {
    defaultMessage: "Resend Code",
    id: "src.components.LoginDialog.resendCode",
  },
  resetPasswordLink: {
    defaultMessage: "Resend Password Link",
    id: "src.components.LoginDialog.resetPasswordLink",
  },
  staffNotAllowed: {
    defaultMessage:
      "Please check your email and password. Do not use your staff login",
    id: "src.pages.LoginPage.staffNotAllowed",
  },
  submit: {
    defaultMessage: "Submit",
    id: "src.components.LoginDialog.submit",
  },
  successfullySent: {
    defaultMessage: "An {communication} has successfully been sent!",
    id: "src.components.LoginDialog.successfullySent",
  },
  tryAgain: {
    defaultMessage: "Try Again",
    id: "src.components.LoginDialog.tryAgain",
  },
  verificationCode: {
    defaultMessage: "Verification Code",
    id: "src.components.LoginDialog.verificationCode",
  },
})
